import { useMutation, useQueryClient } from '@tanstack/react-query'
import { WorkspaceObject } from '../../features/workspaces/types'
import { getQueryKey } from '../../services'
import { showErrorToast } from '@bpinternal/ui-kit-next'
import { handleHttpErrors } from '../../shared'
import { useQueryKeys } from '../useQueryKeys'
import { getApiClient, useAppStore } from '../../stores'

type UpdateWorkspaceParams = { onSuccess?: () => void } & Parameters<
  ReturnType<typeof getApiClient>['updateWorkspace']
>['0']

export function useUpdateWorkspace() {
  const queryClient = useQueryClient()
  const { checkWorkspaceHandle } = useQueryKeys()

  return useMutation({
    mutationFn: async ({ id, ...params }: UpdateWorkspaceParams) => {
      return await getApiClient()
        .updateWorkspace({ id, ...params })
        .catch(handleHttpErrors)
    },
    onSuccess: async (updatedWorkspace, { onSuccess, handle }) => {
      const workspaceQueryKey = getQueryKey('workspaces_/$workspaceId_', { workspaceId: updatedWorkspace.id })
      queryClient.setQueryData<WorkspaceObject>(workspaceQueryKey, () => {
        return updatedWorkspace
      })

      await queryClient.invalidateQueries({ queryKey: getQueryKey('workspaces_') })
      if (handle !== undefined) {
        await queryClient.invalidateQueries({ queryKey: checkWorkspaceHandle(handle) })
      }

      onSuccess?.()
    },
    onError: (error: Error) => {
      showErrorToast(error.message)
    },
  })
}
